/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.12.18",
    versionName: "0.2.0-nightly.2025.12.18",
    versionChannel: "nightly",
    buildDate: "2025-12-18T00:07:08.198Z",
    commitHash: "05dbef548ed704b431fca2115dc7747210ea5c99",
};
